import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface MetricCardProps {
  label: string;
  value: string;
  subValue?: string;
  trend?: 'up' | 'down' | 'flat';
  trendValue?: string;
  variant?: 'info' | 'positive' | 'warning' | 'danger';
  icon?: React.ReactNode;
  className?: string;
}

export default function MetricCard({
  label,
  value,
  subValue,
  trend,
  trendValue,
  variant = 'info',
  icon,
  className = '',
}: MetricCardProps) {
  const variantClass = {
    info: 'metric-card-info',
    positive: 'metric-card-positive',
    warning: 'metric-card-warning',
    danger: 'metric-card-danger',
  }[variant];

  const trendColor = trend === 'up' ? 'text-success' : trend === 'down' ? 'text-danger' : 'text-muted-foreground';
  const TrendIcon = trend === 'up' ? TrendingUp : trend === 'down' ? TrendingDown : Minus;

  return (
    <div className={`card-base card-hover ${variantClass} ${className}`}>
      <div className="flex items-start justify-between mb-3">
        <p className="section-header">{label}</p>
        {icon && (
          <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
            {icon}
          </div>
        )}
      </div>
      <p className="text-3xl font-800 text-foreground font-tabular leading-none mb-1">{value}</p>
      {subValue && <p className="text-xs text-muted-foreground mt-1">{subValue}</p>}
      {trend && trendValue && (
        <div className={`flex items-center gap-1 mt-2 text-xs font-600 ${trendColor}`}>
          <TrendIcon size={13} />
          <span>{trendValue}</span>
        </div>
      )}
    </div>
  );
}